<script setup lang="ts">
const lang = useI18n().locale.value;

</script>

<template>
  <div>
    <div w-full bg-cover h-550 lt-xl:h-275 bg-center
      :style="{ backgroundImage: 'url(' + (useDeviceType().value == 'pc' ? futures_trade.cn.banner : futures_trade.cn.m_banner) + ')' }">
      <div mwc relative h-full>
        <div text-left text-white pt-115 mb-99 lt-xl:pt-35 lt-xl:mb-27>
          <p text-40 fw l-n mb-37 text-accent lt-xl:text-18 lt-xl:mb-10>{{ $t('qhyw') }}</p>
          <p titz max-w-491 lt-xl:text-13 lt-xl:max-w-250>
            {{ $t('lyggfdtzsy') }}
            </p>
        </div>
        <div>
          <!-- <button btn-accent> {{ $t('ljkh') }}</button> -->
        </div>
      </div>
    </div>
    <div pyx lt-xl:pb-0>
      <div mwc>
        <ul f-c-b mb-20 flex-wrap flex-row items-stretch lt-xl:mb-0>
          <li class="group" w="49%" bds-palebluishgray px-30 pt-50 mb-20 h-435 relative hover:bg-accent hover:text-white
            lt-xl:px-15 lt-xl:pt-15 lt-xl:h-auto lt-xl:mb-15 lt-xl:pb-50 lt-xl:w='49%'>
            <p titc l-n mb-25 lt-xl:mb-15>{{ $t('hqqh') }}</p>
            <p titm lt-xl:mb-10>{{ $t('hqqhsqqxdjrsc') }}</p>
            <div f-c-b absolute bottom-49 right-0 w-full px-30 lt-xl:px-15 lt-xl:bottom-15 lt-xl:absolute>
              <p text-accent titm group-hover:text-paleyellowish></p>
              <img lt-xl:h-30 :src="futures_trade.cn.block2_1" alt="" srcset="">
            </div>
          </li>
          <li class="group" w="49%" bds-palebluishgray px-30 pt-50 mb-20 h-435 relative hover:bg-accent hover:text-white
            lt-xl:px-15 lt-xl:pt-15 lt-xl:h-auto lt-xl:mb-15 lt-xl:pb-50 lt-xl:w='49%'>
            <p titc l-n mb-25 lt-xl:mb-15>{{ $t('xgqh') }}</p>
            <p titm lt-xl:mb-10>{{ $t('xgqhszxgjys') }}</p>
            <div f-c-b absolute bottom-49 right-0 w-full px-30 lt-xl:px-15 lt-xl:bottom-15 lt-xl:absolute>
              <p text-accent titm group-hover:text-paleyellowish></p>
              <img lt-xl:h-30 :src="futures_trade.cn.block2_2" alt="" srcset="">
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div pyx pt-0 lt-xl:pt-30 lt-xl:pb-0>
      <div mwc>
        <p tit mb-80 lt-xl:mb-30>{{ $t('qhdys') }}</p>
        <ul f-c-a mb-80 lt-xl:mb-40 lt-xl:f-col flex items-baseline>
          <li w-300 f-c-c f-col lt-xl:w-full lt-xl:mb-20 lt-xl:flex-row lt-xl:items-start>
            <img mb-24 :src="futures_trade.cn.block3_1" alt="" srcset="" lt-xl:mb-15 lt-xl:w-30 lt-xl:mr-20>
            <div f-c-c f-col lt-xl:items-start>
              <p titc mb-20 lt-xl:mb-10>{{ $t('ggdhbl') }}</p>
              <p titm text-left>{{ $t('yzqxbjqhdggl') }}</p>
            </div>
          </li>
          <li w-300 f-c-c f-col lt-xl:w-full lt-xl:mb-20 lt-xl:flex-row lt-xl:items-start>
            <img mb-24 :src="futures_trade.cn.block3_2" alt="" srcset="" lt-xl:mb-15 lt-xl:w-30 lt-xl:mr-20>
            <div f-c-c f-col lt-xl:items-start>
              <p titc mb-20 lt-xl:mb-10>{{ $t('tzmkd') }}</p>
              <p titm text-left>{{ $t('qhdgglg') }}</p>
            </div>
          </li>
          <li w-300 f-c-c f-col lt-xl:w-full lt-xl:mb-0 lt-xl:flex-row lt-xl:items-start>
            <img mb-24 :src="futures_trade.cn.block3_3" alt="" srcset="" lt-xl:mb-15 lt-xl:w-30 lt-xl:mr-20>
            <div f-c-c f-col lt-xl:items-start>
              <p titc mb-20 lt-xl:mb-10>{{ $t('dyhdtzxz') }}</p>
              <p titm text-left>{{ $t('tgwmdptkyz') }}</p>
            </div>
          </li>

        </ul>
      </div>
      <div relative xl:h-440 xl:items-start xl:f-c>
        <div flex-1 bg-test1 w-full h-505 lt-xl:hidden></div>
        <div mwc m-0 bg-white relative flex-shrink-0 lt-xl:px-0 lt-xl:mb="-60">
          <div w-1200 h-505 bg-center bg-cover xl:f-c lt-xl:w-full lt-xl:h-auto
            :style="{ backgroundImage: 'url(' + (useDeviceType().value == 'pc' ? futures_trade.cn.block4 : futures_trade.cn.m_block4) + ')' }"
            text-white>
            <div lt-xl:pt-30 lt-xl:pb-93 lt-xl:px-15>
              <p tit mb-40 lt-xl:mb-15 textl-left lh-50 lt-xl:hidden>{{ $t('lygzqh') }} <br />"{{ $t('cynx') }}"</p>
              <p mb-15 text-18 textl-left xl:hidden>{{ $t('lygzqh') }} "{{ $t('cynx') }}"</p>
              <p titm mb-60 max-w-365 lt-xl:mb-30>
                {{ $t('gzqhsymgtdgp') }} </p>
            </div>
          </div>
          <div bg-mistywhite w-793 h-508 absolute right-0 top-32 pt-60 pl-40 class="tabs" lt-xl:relative lt-xl:h-auto lt-xl:max-h-448 lt-xl:py-30 lt-xl:pl-15 lt-xl:abs_l lt-xl:w='95%' lt-xl:top="-70">
            <ul>
              <li f-c mb-60 lt-xl:mb-30>
                <img w-80 h-80 mr-20 lt-xl:w-40 lt-xl:h-40 lt-xl:mr-15 :src="futures_trade.cn.block4_1" alt="" srcset="">
                <div>
                  <p titc mb-6>{{ $t('szhq') }}</p>
                  <p titm>{{ $t('yyggzqbgg') }}</p>
                </div>
              </li>
              <li f-c mb-60 lt-xl:mb-30>
                <img w-80 h-80 mr-20 lt-xl:w-40 lt-xl:h-40 lt-xl:mr-15 :src="futures_trade.cn.block4_2" alt="" srcset="">
                <div>
                  <p titc mb-6>{{ $t('hphq') }}</p>
                  <p titm>{{ $t('knzjxpzqjhq') }}</p>
                </div>
              </li>
              <li f-c>
                <img w-80 h-80 mr-20 lt-xl:w-40 lt-xl:h-40 lt-xl:mr-15 :src="futures_trade.cn.block4_3" alt="" srcset="">
                <div>
                  <p titc mb-6>{{ $t('xdhq') }}</p>
                  <p titm>{{ $t('yymkcz') }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div flex-1 bg-mistywhite w- h-508 mt-32 lt-xl:hidden></div>
      </div>
    </div>

    <div pyx lt-xl:pt-30>
      <div mwc f-c-b items-start>
        <div>
          <p tit mb-38 lt-xl:mb-20>{{ $t('khfw') }}</p>
          <p titm mb-65 lt-xl:mb-30>{{ $t('blgjylhdjyl') }}</p>
          <ul>
            <li f-c items-start mb-50 lt-xl:mb-20>
              <div text-accent mr-30 i-material-symbols-radio-button-unchecked text-14 lt-xl:text-7 lt-xl:ml-0 lt-xl:mr-15 lt-xl:mb-0 lt-xl:mt-5></div>
              <div>
                <p titc mb-16 lt-xl:mb-10>{{ $t('zhdzzyfw') }}</p>
                <p titm>{{ $t('zczzdy') }}</p>
              </div>
            </li>
            <li f-c items-start mb-50 lt-xl:mb-20>
              <div text-accent mr-30 i-material-symbols-radio-button-unchecked text-14 lt-xl:text-7 lt-xl:ml-0 lt-xl:mr-15 lt-xl:mb-0 lt-xl:mt-5></div>
              <div>
                <p titc mb-16>{{ $t('24xskhfw') }}</p>
                <p titm>{{ $t('zksqjsshqygjs') }}</p>
              </div>
            </li>
            <li f-c items-start mb-50 lt-xl:mb-20>
              <div text-accent mr-30 i-material-symbols-radio-button-unchecked text-14 lt-xl:text-7 lt-xl:ml-0 lt-xl:mr-15 lt-xl:mb-0 lt-xl:mt-5></div>
              <div>
                <p titc mb-16>{{ $t('khjlhxsjyy') }}</p>
                <p titm>{{ $t('hyjyrskxllzy') }}</p>
              </div>
            </li>
            <li f-c items-start mb-50 lt-xl:mb-0>
              <div text-accent mr-30 i-material-symbols-radio-button-unchecked text-14 lt-xl:text-7 lt-xl:ml-0 lt-xl:mr-15 lt-xl:mb-0 lt-xl:mt-5></div>
              <div>
                <p titc mb-16>{{ $t('djvipfw') }}</p>
                <p titm>{{ $t('zxwmdzjjg') }}</p>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <img w-560 lt-xl:hidden :src="futures_trade.cn.block5" alt="" srcset="">
        </div>
      </div>
    </div>
    <!-- <div v-if="lang !== 'cn'" mt-90 w-full bg-cover h-470 bg-center bg-no-repeat :style="{ backgroundImage: 'url(' + index.cn.banner12 + ')' }"
        overflow-auto>

        <div mwc>
          <div class="invest-globally" font-size-36 line-height-50>{{ $t('tzqqjzzj') }}</div>
          <div class="capital-account" font-size-18 line-height-32 mt-30>
            {{ $t('tzqqjzzjjs') }}<span
              class="stock-content"> {{ $t('tzqqjzzjj1') }}</span>{{ $t('tzqqjzzjj3') }}
          </div>
          <ul f-c mb-24 lt-xl:mb-20 lt-xl:f-c-b mt-60>
            <li mr-16 lt-xl:mr-0>
              <button btn-inkgray class="more-detail">{{  $t('learn_more') }}</button>
            </li>
            <li mr-16 lt-xl:mr-0>
              <a-popover :overlay-inner-style="{ padding: 0 }">
                <template #content>
                  <a-qrcode error-level="H" value="https://apps.apple.com/hk/app/sptrader-pro-hd/id1043451438"
                    :bordered="false" />
                </template>
                <div f-c cp>
                  <button btn-inkgray>iPhone{{ $t('download') }}</button>
                </div>
              </a-popover>
            </li>
            <li mr-16 lt-xl:mr-0>
              <a-popover :overlay-inner-style="{ padding: 0 }">
                <template #content>
                  <a-qrcode error-level="H"
                    value="https://play.google.com/store/apps/details?id=hk.com.sharppoint.spmobile.sptraderprohd"
                    :bordered="false" />
                </template>
                <div f-c cp>
                  <button btn-inkgray>Android{{ $t('download') }}</button>
                </div>
              </a-popover>

            </li>
            <li>
              <a href="https://spsystem.biz/download/temp/EP/FRT/sptrader_forthright_setup_r87911.zip">
                <button btn-inkgray>PC{{ $t('download') }}</button>
              </a>
            </li>
          </ul>
        </div>


      </div> -->

  </div>
</template>
<style lang="less" scoped>
.invest-globally {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  color: #504137;
  font-style: normal;
}

.capital-account {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;
  text-align: left;
  font-style: normal;
}

.more-detail {
  border: 1px solid #AA7322;
  color: #AA7322;
  background-color: #ffffff;
}


</style>
